import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import Axios from 'cccisd-axios';
import ClickButton from 'cccisd-click-button';
import Confirm from 'cccisd-confirm';
import notification from 'cccisd-notification';
import IconCancel from 'cccisd-icons/cancel-circle2';
import Tooltip from 'cccisd-tooltip';
import _startCase from 'lodash/startCase';

var Boilerplate = window.cccisd && window.cccisd.boilerplate;

class DenyRequest extends Component {
    static propTypes = {
        row: PropTypes.object,
        settings: PropTypes.object,
        loadData: PropTypes.func,
    };

    deny = async () => {
        const { row, loadData } = this.props;

        const requestId = _get(row, 'requestId');
        const pawnId = _get(row, 'requestor.pawn.pawnId');
        const pawnHash = _get(row, 'requestor.pawn.pawnHash');
        const username = _get(row, 'requestor.user.username');

        let data = {
            requestId,
            pawnId,
            pawnHash,
            username,
        };

        let response = await Axios.post(Boilerplate.route('deny.pending.request'), data);
        if (response && response.data && response.data.status === 'success') {
            notification({
                message: `Request for ${username} was denied.`,
                type: 'success',
                duration: 8000,
            });

            loadData();
        } else {
            notification({
                message: `Error denying request for ${username}.`,
                data: response && response.data && response.data.errors,
                duration: -1,
                type: 'danger',
            });
        }
    };

    confirm = () => {
        const { row } = this.props;
        const username = _get(row, 'requestor.user.username');
        const role = _startCase(_get(row, 'requestData.role'));

        Confirm({
            message: `Are you sure you want to deny ${username}?`,
            description: `You are about to deny user ${username} from joining as a ${role}.`,
            confirmLabel: 'Deny Request',
            abortLabel: 'Cancel',
        })
            .then(() => {
                this.deny();
            })
            .fail(() => {
                // close modal
            });
    };

    render() {
        return (
            <Tooltip title="Deny Request">
                <ClickButton
                    title={
                        <span>
                            <IconCancel />
                        </span>
                    }
                    className="btn btn-xs btn-danger"
                    onClick={this.confirm}
                />
            </Tooltip>
        );
    }
}

export default DenyRequest;
